module.exports = __webpack_public_path__ + "img/awareness-video.a8b2c8f4.svg";